// An array of rows of emojis
export const EditorCustomEmojiRows = [
	[
		{
			name: "cost",
			shortcodes: ["cost"],
			tags: ["cost"],
			group: "General",
			fallbackImage: "/img/symbols/icon_cost.svg",
		},
		{
			name: "power",
			shortcodes: ["power"],
			tags: ["power"],
			group: "General",
			fallbackImage: "/img/symbols/icon_pwr.svg",
		},
		{
			name: "defense",
			shortcodes: ["defense"],
			tags: ["defense"],
			group: "General",
			fallbackImage: "/img/symbols/icon_def.svg",
		},
		{
			name: "life",
			shortcodes: ["life"],
			tags: ["life"],
			group: "General",
			fallbackImage: "/img/symbols/icon_hp.svg",
		},
		{
			name: "intellect",
			shortcodes: ["intellect"],
			tags: ["intellect"],
			group: "General",
			fallbackImage: "/img/symbols/icon_int.svg",
		},
		{
			name: "tap",
			shortcodes: ["tap"],
			tags: ["tap"],
			group: "General",
			fallbackImage: "/img/symbols/icon_t.svg",
		},
		{
			name: "untap",
			shortcodes: ["untap"],
			tags: ["untap"],
			group: "General",
			fallbackImage: "/img/symbols/icon_u.svg",
		},
	],
	[
		{
			name: "chi",
			shortcodes: ["chi"],
			tags: ["chi"],
			group: "General",
			fallbackImage: "/img/symbols/icon_chi.svg",
		},
	],
];
